<template>
  <v-container class="pb-12">
    <base-material-card
      icon="mdi-clipboard-text-outline"
      color="primary"
      inline
      class="mt-12 px-5 py-3"
      v-if="stockProfile"
    >
      <template v-slot:after-heading>
        <div class="title text-no-wrap font-weight-bold">
          Editar Item {{ stockProfile.name }}
        </div>
      </template>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  filled
                  outlined
                  solo
                  :rules="[v => !!v || `${$t('stocks.name')} is required`]"
                  v-model="stockProfile.name"
                  :label="$t('stocks.name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  filled
                  outlined
                  solo
                  v-model="stockProfile.sku"
                  :label="$t('stocks.sku')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  :items="categories"
                  multiple
                  filled
                  outlined
                  :rules="[
                    v => v.length > 0 || `${$t('stocks.category')} is required`
                  ]"
                  solo
                  return-object
                  chips
                  deletable-chips
                  v-model="stockProfile.category"
                  :label="$t('stocks.category')"
                  item-text="name"
                  item-value="name"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  :items="units"
                  chips
                  filled
                  outlined
                  :rules="[v => !!v || `${$t('stocks.unit')} is required`]"
                  solo
                  deletable-chips
                  v-model="stockProfile.unit"
                  :label="$t('stocks.unit')"
                  item-text="name"
                  item-value="name"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="number"
                  filled
                  outlined
                  solo
                  :rules="[v => !!v || `${$t('stocks.unitValue')} is required`]"
                  step="1"
                  v-model.number="stockProfile.partialValue"
                  :label="$t('stocks.unitValue')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="number"
                  step="1"
                  filled
                  outlined
                  :rules="[v => !!v || `${$t('stocks.quantity')} is required`]"
                  solo
                  v-model.number="stockProfile.quanty"
                  :label="$t('stocks.quantity')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'd-flex flex-column'"
      >
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          class="my-2"
          x-large
          width="200"
          @click="$router.back()"
        >
          {{ $t("stocks.cancel") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="success darken-1"
          class="my-2"
          x-large
          width="200"
          @click="save"
        >
          {{ $t("stocks.save") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-col cols="12" v-if="$store.getters['auth/adminAndUp']">
        <v-divider class="my-12"></v-divider>
        <div class="title mb-4">{{ $t("taskProfile.labels.danger") }}</div>
        <v-row dense style="border:1px red solid;border-radius:8px">
          <v-col cols="12" class="d-flex pa-4">
            <div>
              <!-- TODO  TRADUCIR ESTE LABEL A INVENTARIO-->
              <div class="subtitle-1 font-weight-bold">
                {{ $t("taskProfile.labels.deleteTask") }}
              </div>
              <div class="body">
                {{ $t("taskProfile.messages.deleteTask") }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="deleteItem">
              {{ $t("taskProfile.buttons.delete") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return { valid: true };
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    try {
      const stockProfile = await this.$store.dispatch(
        "stocks/bindStockProfile",
        this.$route.params.id
      );
      if (!stockProfile) {
        this.$router.push({ name: "Error" });
      }
      await this.$store.dispatch("stocks/bindCategories");
      await this.$store.dispatch("stocks/bindUnits");
    } catch (error) {
      console.error(error);
      this.$router.push({ name: "Error" });
    } finally {
      loading.close();
    }
  },
  computed: {
    ...mapState("stocks", ["stockProfile", "categories", "units"])
  },
  methods: {
    async deleteItem() {
      const { $vs, $store, $router } = this;
      const res = await this.$dialog.confirm({
        text: "Esta seguro de eliminar este item?",
        title: "Atencion"
      });

      if (res) {
        const loading = $vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });
        try {
          await $store.dispatch("deleteDocument", {
            db: "stocks",
            doc: this.stockProfile.id
          });
          this.$dialog.notify.success(
            "Your stock has been delete successfully",
            {
              position: "top-right",
              timeout: 5000
            }
          );
          $router.push({ name: "Stocks" });
        } catch (error) {
          console.error(error);
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        } finally {
          loading.close();
        }
      }
    },
    async save() {
      const { $vs, $store, $router } = this;
      this.stockProfile.date = new Date();
      if (this.$refs.form.validate()) {
        const res = await this.$dialog.confirm({
          text: this.$t("dashboard.canYouConfirm"),
          title: this.$t("dashboard.checkFields")
        });

        if (res) {
          const loading = $vs.loading({
            background: "#730D0B",
            color: "rgb(255, 255, 255)",
            opacity: 1,
            type: "square"
          });
          try {
            await $store.dispatch("updateDocument", {
              db: "stocks",
              data: this.stockProfile,
              doc: this.stockProfile.id
            });
            this.$dialog.notify.success(
              "Your stock has been update successfully",
              {
                position: "top-right",
                timeout: 5000
              }
            );
            $router.push({ name: "Stocks" });
          } catch (error) {
            console.error(error);
            this.$dialog.notify.error(error, {
              position: "top-right",
              timeout: 5000
            });
          } finally {
            loading.close();
          }
        }
      }
    }
  }
};
</script>

<style></style>
